import { track } from 'lib/babylistHealthAnalytics'
import { decorateEventPayload } from './decorateEventPayload'

export interface PreCheckoutModalCompletedEventMetadata {
  freeGiftSelected: boolean
}

export const preCheckoutModalCompletedEvent =
  (tracker: any) =>
  ({ freeGiftSelected }: PreCheckoutModalCompletedEventMetadata) => {
    const payload = decorateEventPayload({
      event: track.dmePreCheckoutModalCompleted,
      freeGiftSelected,
    })
    tracker.trackEvent(payload)
  }
